module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/icon-chapel-course-db2cd960a080fae0cd1f67c6a7eddda2.svg";